<template>
  <div class="disclaimer" :class="$mq">
    <p>
      <span v-html="$t('Comeback.Disclaimer.disclaimer')"></span>
      <span v-if="hasElec">{{ $t('Comeback.Disclaimer.forElec') }} <a :href="elecCard" target="_blank">
        {{ $t('Comeback.Disclaimer.elecCard') }}</a>
      </span>

      <span v-if="hasElec && hasGas">{{ $t('Comeback.Disclaimer.and') }}</span>

      <span v-if="hasGas">{{ $t('Comeback.Disclaimer.forGas') }} <a :href="gasCard" target="_blank">{{ $t('Comeback.Disclaimer.gasCard') }}</a>
      </span>

      {{ $t('Comeback.Disclaimer.part3') }}
    </p>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "Disclaimer",
  props: {
    rateCards: {
      type: Array
    }
  },
  computed: {
    ...mapGetters('comeback', ['hasElec', 'hasGas']),
    elecCard() {
      return this.rateCards
        .filter(card => card.energy === 'EL')
        .map(card => card.url)[0]
    },
    gasCard() {
      return this.rateCards
        .filter(card => card.energy === 'NG')
        .map(card => card.url)[0]
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  text-align: left;
}

.disclaimer {
  font-size: 0.8rem;
  margin: 20px 0;

  &.desktop {
    margin: 20px auto;
    width: 700px;
  }
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Comeback/ColdLoss/Disclaimer.vue